import { sdk } from '@wix/image-kit';
export const getMediaManagerImageUrl = (image, width, height) => {
    if (!image?.id) {
        return null;
    }
    const mediaUrl = sdk.getScaleToFillImageURL(image.id, image.width, image.height, width ?? image.width, height ?? image.height, {
        quality: 90,
    });
    const isSvg = mediaUrl.toLowerCase().endsWith('.svg');
    return isSvg ? mediaUrl.replace('/media/', '/shapes/') : mediaUrl;
};
//# sourceMappingURL=media-manager-handler.js.map